Object.assign(exports, require('./write'))
